// src/components/admin/contract/security-deposit/SecurityDepositApi.ts

import axios from "axios";

  
// src/components/admin/contract/security-deposit/types.ts

export interface SecurityDeposit {
    id?: string;
    contractId: string;
    depositType: string;
    instrumentNo: string;
    amount: number;
    depositCreatedDate: string;
    depositSubmitedDate: string;
    bankAccountNo: string;
    bankName: string;
    accountHolderName: string;
    bankAddress: string;
    status: string;
    comment: string;
    depositeReturnedDate?: string;
    depositTransferedOwnAcDate?: string;
    createdAt?: string;
    updatedAt?: string;
    createdBy?: string;
    updatedBy?: string;
  }

  const API_BASE = 'http://localhost:7861/api/contracts';

// Get all deposits for a specific contract
export const getSecurityDeposits = (contractId: string) => {
  return axios.get(`${API_BASE}/${contractId}/security-deposit`);
};

// Get a single deposit by its ID
export const fetchSecurityDepositById = (contractId: string, depositId: string) => {
  return axios.get(`${API_BASE}/${contractId}/security-deposit/${depositId}`);
};

// Create a new security deposit
export const createSecurityDeposit = (contractId: string, payload: SecurityDeposit) => {
  return axios.post(`${API_BASE}/${contractId}/security-deposit`, payload);
};

// Update an existing deposit
export const updateSecurityDeposit = (
  contractId: string,
  depositId: string,
  payload: SecurityDeposit
) => {
  return axios.put(`${API_BASE}/${contractId}/security-deposit/${depositId}`, payload);
};

// Delete a deposit
export const deleteSecurityDeposit = ( depositId: string,contractId: string) => {
  return axios.delete(`${API_BASE}/${contractId}/security-deposit/${depositId}`);
};
